module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Les circuits"},"en":{"title":"Tours"}}')
  delete Component.options._Ctor
}
